import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Error429Service {

  private readonly ERROR_KEY = 'error';

  setError(hasError: boolean) {
    localStorage.setItem(this.ERROR_KEY, JSON.stringify(hasError));
  }

  getError(): boolean {
    const errorData = localStorage.getItem(this.ERROR_KEY);
    return errorData ? JSON.parse(errorData) : false; // Valor predeterminado a false si no se encuentra el valor en el localStorage
  }

  clearError() {
    localStorage.removeItem(this.ERROR_KEY);
  }
}
